import React from 'react';
import ActionButton from '../../components/action-button';
import FooterItemWrapper from '../../components/footer-item-wrapper';
import { TFooterLayoutItem } from '../../types/layout/footer';
import { ILayoutWithOwner, ILayoutWithRowId } from '../layout-factory';
import ActionModal from '../../components/action-modal';

interface IFooterFactoryProps {
    layout: TFooterLayoutItem[];
}

function FooterFactory({ layout, idOwner, rowId }: IFooterFactoryProps & ILayoutWithOwner & ILayoutWithRowId) {
    const renderFooterItem = (item: TFooterLayoutItem) => {
        switch (item.type) {
            case 'action': {
                return (
                    <FooterItemWrapper>
                        <ActionButton {...item} idOwner={idOwner} rowId={rowId} />
                    </FooterItemWrapper>
                );
            }
            case 'action-modal': {
                return (
                    <FooterItemWrapper>
                        <ActionModal {...item} idOwner={idOwner} />
                    </FooterItemWrapper>
                );
            }
            default: {
                return null;
            }
        }
    };

    return (
        <>
            {React.Children.toArray(layout.map(renderFooterItem))}
        </>
    );
}

export default FooterFactory;
